

function DictionaryContainer() {
    return (
        <div>
            <h1 style={{textAlign: "center"}}>Dictionary</h1>
        </div>
    );
}

export default DictionaryContainer;
